/**
 * Chatbot Scroll Fix for Desktop
 * Ensures proper mouse wheel scrolling in chatbot messages container
 * with smooth GSAP animations, preventing ScrollSmoother interference
 * Mobile uses native CSS scrolling
 */

document.addEventListener('DOMContentLoaded', function() {
    const chatMessagesContainer = document.querySelector('.arc-chat-messages');
    
    if (!chatMessagesContainer) {
        return;
    }
    
    // Smooth scroll settings for desktop
    const scrollSettings = {
        duration: 0.4,
        ease: "power2.out",
        scrollStep: 200 // pixels to scroll per wheel event
    };
    
    let isScrolling = false;
    let scrollTween = null;
    
    // Only apply smooth scrolling on desktop (where ScrollSmoother is active)
    if (typeof gsap !== 'undefined') {
        // Prevent GSAP ScrollSmoother from interfering with chatbot scrolling (desktop only)
        chatMessagesContainer.addEventListener('wheel', function(e) {
            e.stopPropagation();
            e.preventDefault();
            
            const delta = e.deltaY;
            const currentScrollTop = this.scrollTop;
            const maxScrollTop = this.scrollHeight - this.clientHeight;
            
            // Calculate target scroll position
            const scrollDirection = delta > 0 ? 1 : -1;
            const targetScrollTop = Math.max(0, Math.min(
                currentScrollTop + (scrollDirection * scrollSettings.scrollStep),
                maxScrollTop
            ));
            
            // Improved boundary detection - allow small movements even when at boundaries
            const tolerance = 1; // 1px tolerance for boundary detection
            const isAtTop = currentScrollTop <= tolerance;
            const isAtBottom = currentScrollTop >= (maxScrollTop - tolerance);
            
            // If we're at bottom and trying to scroll down, or at top and trying to scroll up,
            // still allow a small animation to provide visual feedback
            if ((isAtBottom && scrollDirection > 0) || (isAtTop && scrollDirection < 0)) {
                // Create a small bounce effect at boundaries
                const bounceDistance = 5;
                const bounceTarget = isAtBottom ? 
                    Math.min(maxScrollTop, currentScrollTop + bounceDistance) :
                    Math.max(0, currentScrollTop - bounceDistance);
                
                if (scrollTween) {
                    scrollTween.kill();
                }
                
                scrollTween = gsap.to(this, {
                    scrollTop: bounceTarget,
                    duration: 0.15,
                    ease: "power2.out",
                    yoyo: true,
                    repeat: 1,
                    onStart: () => {
                        isScrolling = true;
                    },
                    onComplete: () => {
                        isScrolling = false;
                        scrollTween = null;
                    }
                });
                return;
            }
            
            // Don't animate if we're already at the target position (with tolerance)
            if (Math.abs(targetScrollTop - currentScrollTop) <= tolerance) {
                return;
            }
            
            // Kill any existing scroll animation
            if (scrollTween) {
                scrollTween.kill();
            }
            
            // Create smooth scroll animation
            scrollTween = gsap.to(this, {
                scrollTop: targetScrollTop,
                duration: scrollSettings.duration,
                ease: scrollSettings.ease,
                onStart: () => {
                    isScrolling = true;
                },
                onComplete: () => {
                    isScrolling = false;
                    scrollTween = null;
                }
            });
        }, { passive: false });
    }
    
    // Add helper functions for programmatic scrolling
    chatMessagesContainer.scrollToBottom = function(smooth = true) {
        const maxScrollTop = this.scrollHeight - this.clientHeight;
        
        if (smooth && typeof gsap !== 'undefined') {
            gsap.to(this, {
                scrollTop: maxScrollTop,
                duration: scrollSettings.duration,
                ease: scrollSettings.ease
            });
        } else {
            this.scrollTop = maxScrollTop;
        }
    };
    
    chatMessagesContainer.scrollToPosition = function(position, smooth = true) {
        const maxScrollTop = this.scrollHeight - this.clientHeight;
        const targetScrollTop = Math.max(0, Math.min(position, maxScrollTop));
        
        if (smooth && typeof gsap !== 'undefined') {
            gsap.to(this, {
                scrollTop: targetScrollTop,
                duration: scrollSettings.duration,
                ease: scrollSettings.ease
            });
        } else {
            this.scrollTop = targetScrollTop;
        }
    };
});